module.exports = __webpack_public_path__ + "img/期刊匹配：外文期刊.3f5ed0cf.png";